import React from 'react';

import Featured from 'components/featured';

import './styles.scss';

const featuredImage1 = 'about/image_1.jpg';
const featuredImage2 = 'about/image_2.jpg';
const featuredImage3 = 'about/image_3.jpg';

const AboutFeatured = () => (
  <div className="about-featured">
    <div className="container-md about-featured__container">
      <Featured
        classNames="about-featured__featured-row"
        description="about.featured.f1.description"
        image={featuredImage1}
        linkProps={{
          text: 'about.featured.f1.linktext',
          to: '/how-it-works'
        }}
        title="about.featured.f1.title"
      />
      <Featured
        classNames="about-featured__featured-row"
        description="about.featured.f2.description"
        image={featuredImage2}
        invert
        linkProps={{
          text: 'about.featured.f2.linktext',
          to: '/transporter'
        }}
        title="about.featured.f2.title"
      />
      <Featured
        classNames="about-featured__featured-row"
        description="about.featured.f3.description"
        image={featuredImage3}
        linkProps={{
          text: 'about.featured.f3.linktext',
          to: '/partners'
        }}
        title="about.featured.f3.title"
      />
    </div>
  </div>
);

export default AboutFeatured;
